import { getDivisor } from './getDivisor'

export const getRoundedValue = (value: number, rounding: string = '') => {
  const divisor = getDivisor(rounding)
  if (divisor > 1) {
    return value / divisor
  }

  return value
}

export const getRestoredValue = (value: number, rounding: string = '') => {
  const divisor = getDivisor(rounding)
  if (divisor > 1) {
    return value * divisor
  }

  return value
}
